(function () {
  const docEl = document.documentElement;
  const startedAt = Date.now();
  const minVisibleTime = 300;
  const maxWaitTime = 2800;
  const imageWaitTime = 1600;
  let didFinish = false;

  const wait = (delay) => new Promise((resolve) => window.setTimeout(resolve, delay));

  const domReady = () => {
    if (document.readyState !== 'loading') return Promise.resolve();

    return new Promise((resolve) => {
      document.addEventListener('DOMContentLoaded', resolve, { once: true });
    });
  };

  const imageReady = (image) => {
    if (image.complete && image.naturalWidth > 0) {
      return image.decode ? image.decode().catch(() => {}) : Promise.resolve();
    }

    return new Promise((resolve) => {
      const finish = () => {
        window.clearTimeout(timeoutId);
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        resolve();
      };
      const timeoutId = window.setTimeout(finish, imageWaitTime);

      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
    });
  };

  const criticalImagesReady = () => {
    const images = Array.from(document.querySelectorAll('[data-preload-critical]'));

    if (!images.length) return Promise.resolve();

    return Promise.all(images.map(imageReady));
  };

  const markLoaded = () => {
    if (didFinish) return;

    didFinish = true;

    const remainingMinTime = Math.max(0, minVisibleTime - (Date.now() - startedAt));

    window.setTimeout(() => {
      if (document.body) {
        document.body.classList.add('is-loaded');
      }

      docEl.classList.add('site-preloader-loaded');
      docEl.classList.remove('site-preloader-active');

      window.setTimeout(() => {
        docEl.classList.add('site-preloader-finished');
      }, 700);
    }, remainingMinTime);
  };

  const readyEnough = domReady().then(criticalImagesReady);

  Promise.race([
    readyEnough,
    wait(maxWaitTime)
  ]).then(markLoaded);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) markLoaded();
  });
})();
